





















































import { Component, Provide, Vue } from "vue-property-decorator";
import { menu } from "@/config/host.config";

import { AxiosError, AxiosResponse, AxiosRequestConfig } from "axios";
import { IBar } from "@/@types/menu/bars/bars";

import BarsList from "@/components/tables/bars/bars-list.vue";
import AddBarForm from "@/components/forms/bars/add-bar-form.vue";
import ButtonBack from "@/components/buttons/button-back.vue";

@Component({
  components: {
    BarsList,
    AddBarForm,
    ButtonBack,
  },
})
export default class Menubars extends Vue {
  @Provide() barFolder = "menu/bars";
  barList: Array<IBar> = [];
  show = false;
  alertMessage = "error.empty";
  variant = "danger";
  bar: IBar | null = null;
  showAdd = true;

  deleteBar(id: string): void {
    if (!id) return;
    const i = this.barList.findIndex((el) => el._id == id);
    if (i < 0) {
      this.createBarList();
      return;
    }

    this.barList.splice(i, 1);
  }

  changeBar(id: string): void {
    for (const bar of this.barList) {
      if (bar._id == id) {
        this.bar = Object.assign({}, bar);
        this.showAdd = false;
        return;
      }
    }
  }

  async sendingBar(id: string, bar: Partial<IBar>): Promise<void> {
    if (!bar) return;
    this.showAdd = true;
    this.bar = null;
    const method = id ? "put" : "post";
    const url = id ? `${menu.bars}/${id}` : menu.bars;
    let data: { [x: string]: any } = {};

    const i = this.barList.findIndex((el) => el._id == id);
    if (!id || i < 0) data = bar;
    else {
      for (const key of Object.keys(bar)) {
        if (bar[key as keyof IBar] != this.barList[i][key as keyof IBar]) {
          data[key] = bar[key as keyof IBar];
        }
      }
    }
    try {
      const barRes = await this.$axios({ url, method, data });
      if (barRes.status === 200) {
        this.$notify({
          group: "global",
          text: String(this.$i18n.t("error.200")),
        });
        if (id) {
          for (const key of Object.keys(bar)) {
            this.$set(this.barList[i], key, bar[key as keyof IBar]);
          }
        } else this.barList.push(barRes.data);
        return;
      }
      this.$notify({
        group: "global",
        text: String(this.$i18n.t("error.empty400")),
        type: "warn",
      });
    } catch (error) {
      this.$notify({
        group: "global",
        text: String(this.$i18n.t("error.empty400")),
        type: "warn",
      });
    }
  }

  async getBars(config: AxiosRequestConfig | undefined): Promise<Array<IBar>> {
    const url = menu.bars;
    return new Promise((res, rej) => {
      this.$axios
        .get(url, config)
        .then((bars: AxiosResponse) => {
          if (bars.status === 200) {
            res(bars.data);
          }
        })
        .catch((e: AxiosError) => {
          console.log(e);
          rej(e);
        });
    });
  }

  createBarList(): void {
    const config: AxiosRequestConfig = {
      params: {
        "match[deleted][value]": false,
      },
    };
    this.getBars(config)
      .then((bars: IBar[]) => {
        this.barList = bars;
        if (this.barList.length > 0) {
          this.show = true;
          this.alertMessage = "";
        } else {
          this.show = false;
          this.alertMessage = String(
            this.$i18n.t("error.emptyList", {
              name: this.$i18n.t("Menu.name"),
            })
          );
          this.variant = "success";
        }
      })
      .catch((e: AxiosError) => {
        this.show = false;
        this.alertMessage = String(
          this.$i18n.t(`error.${e.response ? e.response.status : e.message}`)
        );
      });
  }

  mounted(): void {
    this.createBarList();
  }
}
